import React from "react";

import LawFirmsProvider from "./context/LawFirmsProvider";
import LawFirmTeamsWithState from "./LawFirmTeamsWithState";

const LawFirmTeams = ({ userId }) => {
  return (
    <div id="Law-Firm-Teams" data-testid="Law-Firm-Teams" className="px-6">
      <LawFirmsProvider>
        <LawFirmTeamsWithState userId={userId} />
      </LawFirmsProvider>
    </div>
  );
};

export default LawFirmTeams;
